import React, { useState } from 'react'
import '../../styles/5-Portfolio/Portfolio.css'
import { projectList } from '../../models/projectList'
import Project from './Project'
import ProjectItem from './ProjectItem'
import img1 from '../../assets/images/project-1.jpg'
import useLanguageContext from '../../hooks/useLanguageContext'

const Portfolio = () => {

  const [ currentProject, setCurrentProject ] = useState({
    name: "Project-name",
    id: "01",
    src: img1,
    repositoryURL: "https://github.com/Anselmo1122/Calculadora-React",
    demoURL: "https://calculadora-react-adh.netlify.app",
  })

  function updateProject(project) {
    setCurrentProject(project)
  } 

  const languageState = useLanguageContext()

  return (
    <section id='portfolio'>
      <h2 className='portfolio__title'>
        {
          languageState ? "Portfolio" : "Portafolio"
        }
      </h2>
      <div className='portfolio__projects'>
        <Project data={currentProject} />
        <ul className='projects__list'>
          {
            projectList.map((project)=>{
              return(
                <ProjectItem 
                  key={project.id} 
                  updateProject={updateProject} 
                  project={project} 
                  isActive={currentProject.id === project.id ? true : false}
                />
              )
            })
          }
        </ul>
      </div>
    </section>
  )
}

export default Portfolio